import React from "react"
import ReactPaginate from "react-paginate"
import classes from "./Pagination.module.scss"

interface IPaginationProps {
  onPageChange: ({ selected }: { selected: number }) => void
  pageRangeDisplayed: number
  pageCount: number
  forcePage: number
}

export default function Pagination({onPageChange, pageRangeDisplayed, pageCount, forcePage}: IPaginationProps) {

  if (pageCount > 1) {
    return (
      <ReactPaginate
        breakLabel="..."
        nextLabel="›"
        onPageChange={onPageChange}
        pageRangeDisplayed={pageRangeDisplayed}
        pageCount={pageCount}
        forcePage={forcePage}
        previousLabel="‹"
        className={classes.list}
        pageClassName={classes.item}
        activeClassName={classes.item_active}
        pageLinkClassName={classes.link}
        activeLinkClassName={classes.link_active}
        previousClassName={[classes.item, classes.nav_prev].join(" ")}
        nextClassName={[classes.item, classes.nav_next].join(" ")}
        previousLinkClassName={classes.nav_link}
        nextLinkClassName={classes.nav_link}
        disabledClassName={classes.item_disabled}
        disabledLinkClassName={classes.nav_link_disabled}
      />
    )
  } else {
   return null
  }
}